PJQ.helpers.numberFormatHelpers = {
    createFormatStringPreview(numberFormat) {
        let result = '';
        _.each(numberFormat, function (token) {
            if (token.isText)
                result += token.label;
            else
                result += '<span class="border-1p border-light p-1 bg-light">[' + token.label + ']</span>';
        });
        return result;
    }
};

PJQ.views.settings.NumberFormatInput = PJQ.views.BaseView.extend({
    defaults: {
        commitmentType: null,
        settings: null,
        customFields: null,
        numberFormatProperty: 'numberFormat',
        onSave: _.noop()
    },
    afterRender: function () {
        if (this.options.commitmentType === PJQ.constants.commitments.commitmentType.SUBCONTRACT) {
            this.options.numberFormatProperty = 'subcontractNumberFormat';
        } else if (this.options.commitmentType === PJQ.constants.commitments.commitmentType.PURCHASE_ORDER) {
            this.options.numberFormatProperty = 'purchaseOrderNumberFormat';
        }

        this.numberFormat = this.options.settings.get(this.options.numberFormatProperty);
        let editButton = $('<button type="button" class="btn btn-transparent-light text-info btn-sm number-format-edit ml-1"><i class="fal fa-pencil"></i></button>');
        this.$el.closest('.form-group').find('label').append(editButton);
        editButton.on('click', _.bind(this.edit, this));

        this.renderFormatString();
    },
    edit: function () {
        new PJQ.views.settings.NumberFormatEditModal({
            settings: this.options.settings,
            numberFormatProperty: this.options.numberFormatProperty,
            onSave: _.bind(function (value) {
                this.numberFormat = value;
                this.options.settings.set(this.options.numberFormatProperty, value);
                this.renderFormatString();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(value);
                }
            }, this)
        });
    },
    renderFormatString: function () {
        this.$el.html('<div class="alert alert-link wd-100 min-ht-40p p-2" role="alert">' + PJQ.helpers.numberFormatHelpers.createFormatStringPreview(this.numberFormat) + '</div>');
    }
});

PJQ.views.settings.NumberFormatEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'modal-number-format-edit'),
        minWidth: 800,
        numberFormatProperty: 'numberFormat',
        onSave: _.noop(),
        parentView: null
    },
    events: {
        'click a.new-token': 'addToken',
        'click .edit-token': 'editToken',
        'change .input-ct-min-len': 'counterMinLengthChanged',
        'click .cancel-edit-token': 'cancelEdit',
        'click .delete-token': 'deleteToken',
        'click .save-token': 'saveToken',
        'click .save': 'saveFormat'
    },
    beforeModalCreated: async function () {
        let numFmt = this.options.settings.get(this.options.numberFormatProperty);
        if (numFmt != null) {
            this.numberFormat = [...numFmt];
        } else {
            this.numberFormat = [];
        }

        this.tokens = [
            {
                token: '',
                label: 'Enter Text',
                isText: true
            },
            {
                token: 'project.projectId',
                label: 'Project Id',
                category: 'Project Details'
            },
            {
                token: 'project.startDate',
                label: 'Project Start',
                isDate: true,
                dateFormatId: 0,
                category: 'Project Details'
            },
            {
                token: 'today',
                label: 'Current Date',
                isDate: true,
                dateFormatId: 0
            }];

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        if (this.erpIntegration != null) {
            this.tokens.push({
                token: 'externalProjectNumber',
                label: 'ERP Project Id',
                category: 'Project Details'
            });
        }

        // add the custom fields
        _.each(PJQ.app.session.customFields.project[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
            switch (customField.get('fieldType')) {
                case PJQ.constants.customFields.fieldTypes.DATE:
                case PJQ.constants.customFields.fieldTypes.DATETIME:
                    this.tokens.push(
                        {
                            token: 'fieldValue' + customField.get('fieldNumber'),
                            label: customField.get('fieldName'),
                            isDate: true,
                            dateFormatId: 0,
                            category: 'Project Details'
                        });
                    break;
                case PJQ.constants.customFields.fieldTypes.INT:
                case PJQ.constants.customFields.fieldTypes.TEXT:
                    this.tokens.push(
                        {
                            token: 'fieldValue' + customField.get('fieldNumber'),
                            label: customField.get('fieldName'),
                            category: 'Project Details'
                        });
                    break;
                // case PJQ.constants.customFields.fieldTypes.CHOICE:
                //     if (!customField.get('isMultipleChoice')) {
                //         this.tokens.push(
                //             {
                //                 token: 'fieldValue' + customField.get('fieldNumber'),
                //                 label: customField.get('fieldName')
                //             });
                //         break;
                //     }
                //     break;
            }
        }, this));

        this.tokens.push({
            token: 'counter',
            label: 'Counter'
        });

        this.render();
    },
    renderData: function () {
        return {
            tokens: this.tokens
        };
    },
    afterRender: function () {
        this.$('.number-format-preview').html(PJQ.helpers.numberFormatHelpers.createFormatStringPreview(this.numberFormat));

        this.editRow = null;
        this.dateFormatSelectPicker = null;
        this.datatable = new PJQ.views.dataTables.DataTable({
            el: this.$('.token-datatable'),
            data: this.numberFormat,
            isHideSearch: true,
            order: [],
            pageLength: 99999,
            sortableOptions: {
                data: this.numberFormat,
                containment: ".token-datatable",
                stop: _.bind(function () {
                    let self = this, rows = [];
                    this.$('.token-datatable tbody tr').each(function (a, b) {
                        rows.push(self.datatable.getRow(b).data());
                    });

                    this.numberFormat = rows;
                    this.render();
                }, this)
            },
            bSort: false,
            onTableDraw: _.bind(function (dataTable) {
                if (this.$('.token-text').length) {
                    this.$('.token-text').inputmask('', {
                        regex: '^[0-9A-Z-a-z\.\-]*$'
                    })
                    this.$('.token-text').focus();
                } else if (this.$('.date-format').length) {
                    this.dateFormatSelectPicker = new PJQ.inputs.Selectpicker({
                        el: this.$('.date-format'),
                        isIntChoices: true,
                        isMultiple: false,
                        defaultValue: parseInt(this.$('.date-format').data('default'))
                    });
                    this.$('.date-format').focus();
                }

            }, this),
            columns: [
                {
                    "title": "Element",
                    "orderable": false,
                    "searchable": false,
                    "render": (data, type, row) => {
                        if (this.editRow === row) {
                            if (row.isText) {
                                return '<input type="text" class="form-control token-text " value="' + row.label + '" placeholder="Enter Text" >';
                            } else if (row.isDate) {
                                return '<div class="d-flex align-items-center"><div class="d-flex flex-fill">' + '[' + row.label + ']' + '</div><div class="wd-200p"><select class="date-format" data-default="' + row.dateFormatId.toString() + '"><option value="0">Full Date</option><option value="1">Month</option><option value="2">Day</option><option value="3">Year (2-Digit)</option><option value="4">Year</option></select></div></div>';
                            }

                            return '';
                        } else {
                            if (row.token === 'counter') {
                                return '<div class="d-flex align-items-center"><div>' + '[' + row.label + ']' + '</div><div class="ml-3 fs-14 font-weight-bold">Min. Length:</div><input type="number" min="1" max="5" style="width:60px" class="form-control ml-1 input-ct-min-len" value="' + (row.minLength ?? 4) + '" /></div>';
                            } else if (row.isText) {
                                return row.label;
                            } else {
                                return '[' + row.label + ']' + (row.isDate ? ' (' + PJQ.constants.commitments.commitmentNumberTokenDateFormatNames[row.dateFormatId] + ')' : '');
                            }
                        }
                    }
                },
                {
                    "title": '',
                    "render": _.bind(function (data, type, row) {
                        let html = '<div class="show-on-row-hover">';
                        if (this.editRow === row) {
                            html += '<button type="button" class="btn btn-success save-token ml-1" title="Save"><i class="fal fa-save"></i></button>';
                            html += '<button type="button" class="btn btn-danger cancel-edit-token ml-1" title="Cancel Edit"><i class="fal fa-times"></i></button>';
                        } else {
                            if (row.isText || row.isDate)
                                html += '<button type="button" class="btn btn-info edit-token ml-1" title="Edit"><i class="fal fa-pencil"></i></button>';

                            html += '<button type="button" class="btn btn-danger delete-token ml-1" title="Delete"><i class="fal fa-trash"></i></button>';
                        }
                        html += '</div>';
                        return html;
                    }, this),
                    "orderable": false,
                    "searchable": false,
                    "width": "75px",
                    "className": "text-right",
                    "visible": true
                }
            ],
            dom: 't'
        });
        // '<"top"<"clear">>rt<"bottom"p<"clear">>'
    },
    counterMinLengthChanged: function (e) {
        let $target = $(e.currentTarget),
            $row = $target.closest('tr')[0],
            row = this.datatable.getRow($row),
            token = row.data();

        if (token == null) {
            return;
        }

        let minLen = parseInt($target.val());
        if (!isNaN(minLen) && minLen >= 1 && minLen <= 5) {
            token.minLength = minLen;
        }
    },
    addToken: function (e) {
        let tokenIndex = $(e.currentTarget).data('tokenIndex'),
            newToken = _.clone(this.tokens[tokenIndex]);
        this.editRow = null;
        if (newToken.isText) {
            newToken.label = '';
            this.editRow = newToken;
        } else if (newToken.isDate) {
            this.editRow = newToken;
        }

        if (this.editRow)
            this.$('.save').prop('disabled', true);

        this.datatable.addRow(newToken);

        this.isAdding = true;


        this.$('.number-format-preview').html(PJQ.helpers.numberFormatHelpers.createFormatStringPreview(this.datatable.dataTable.data()));
    },
    editToken: function (e) {
        let row = this.datatable.getRow($(e.currentTarget).closest('tr')[0]);
        this.editRow = row.data();
        this.$('.save').prop('disabled', true);
        row.invalidate().draw();
    },
    cancelEdit: function (e) {
        let row = this.datatable.getRow($(e.currentTarget).closest('tr')[0]);
        this.editRow = null;
        this.dateFormatSelectPicker = null;
        this.$('.save').prop('disabled', false);
        if (this.isAdding) {
            this.datatable.removeRow(row);
        } else {
            row.invalidate().draw();
        }
        this.isAdding = false;
    },
    deleteToken: function (e) {
        let row = this.datatable.getRow($(e.currentTarget).closest('tr')[0]);
        if (row == null) {
            return;
        }

        this.datatable.removeRow(row);
        this.$('.number-format-preview').html(PJQ.helpers.numberFormatHelpers.createFormatStringPreview(this.datatable.dataTable.data()));
    },
    saveToken: function (e) {
        let row = this.datatable.getRow($(e.currentTarget).closest('tr')[0]),
            data = row.data();
        if (data.isText) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.token-text'), true);
            let value = this.$('.token-text').val().trim();
            if (_.size(value) === 0) {
                PJQ.helpers.inputHelpers.setInputError(this.$('.token-text'), false);
                return;
            }

            data.label = value;
        } else if (data.isDate) {
            data.dateFormatId = this.dateFormatSelectPicker.getValue();
            this.dateFormatSelectPicker = null;
        }

        this.editRow = null;
        this.isAdding = false;
        this.$('.save').prop('disabled', false);
        row.invalidate().draw();
        this.$('.number-format-preview').html(PJQ.helpers.numberFormatHelpers.createFormatStringPreview(this.datatable.dataTable.data()));
    },
    saveFormat: function () {
        if (typeof this.options.onSave === 'function') {
            let tokens = [];
            for (let i = 0; i < this.datatable.dataTable.data().length; i++)
                tokens.push(this.datatable.dataTable.data()[i]);

            this.options.onSave(tokens);
        }

        this.removeModal();
    }
});